
import EventBus from './EventBus'

export function ErrorHandler (error: { response: { status: number; }; message: string; }, alertItem: ()=>void) {
  if (error.response && error.response.status === 401) {
    EventBus.dispatch('logout', 'session timeout')
    localStorage.removeItem('session_polac_physical')
    window.location.href = '/login'
  }
  return alertItem
}
